import { jsx as _jsx } from "react/jsx-runtime";
import { SearchFull } from '@aviv-search/refiner/full';
import { useLocale } from '@aviv-unified-frontend/runtime/i18n';
import { useBrandConfiguration } from '@search/core/brands/context';
import { BaseFilterBar } from '@search/core/components/BaseFilterBar';
import { useScrollOffset } from '@search/core/hooks/useScrollOffset';
import { useStageConfiguration } from '@search/core/hooks/useStageConfiguration';
import { useRef } from 'react';
import { useAppContext } from '../../contexts/AppContext';
export const FilterBarTestId = 'search-filterbar-testid';
export const FilterBar = () => {
    const ref = useRef(null);
    const [searchModel, setSearchModel] = useAppContext((store) => [store.searchModel, store.setSearchModel]);
    const { stage } = useStageConfiguration();
    const { brand, searchType } = useBrandConfiguration();
    const { language } = useLocale();
    const submitSearch = async (nextSearchModel) => {
        setSearchModel(nextSearchModel);
    };
    const [isStuck] = useScrollOffset({
        element: ref,
        offset: 1,
    });
    return (_jsx(BaseFilterBar, { ref: ref, testId: FilterBarTestId, isStuck: isStuck, children: searchModel && (_jsx(SearchFull, { initialModel: searchModel, stage: stage, brand: brand, onSubmit: submitSearch, locale: language, countMode: "default", searchType: searchType })) }));
};
